import { render, staticRenderFns } from "./CategoryManagerWidget.vue?vue&type=template&id=2872e056"
import script from "./CategoryManagerWidget.vue?vue&type=script&lang=js"
export * from "./CategoryManagerWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports